// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3tjw_","title":"AfterBackImages_title__2Ydxr","images":"AfterBackImages_images__1lkfO"};